import { useAppSelector } from "../features/helpers";
import { getLoggedUserType } from "../store/AuthSlice";
import { AppRole, canAccess, normalizeRole, RouteKey } from "./permissions";

/**
 * Hook unico para tudo de RBAC.
 *
 * const { role, can } = useRole();
 * if (!can("purchases")) return null;
 */
export const useRole = () => {
    const raw  = useAppSelector(getLoggedUserType);
    const role: AppRole | null = normalizeRole(raw);

    return {
        /** AppRole normalizado, ou null se nao logado/role invalido */
        role,
        /** Valor cru do estado (debug) */
        raw,
        /** Helper: o usuario logado pode acessar essa routeKey? */
        can: (key: RouteKey) => canAccess(role, key),
    };
};
